import ReCAPTCHA from 'react-google-recaptcha';

export const CaptchaToken = ({
  recaptchaRef,
  handleRecaptchaChange,
  handleReaptchaError,
  recaptchaSiteKey,
}) => (
  <ReCAPTCHA
    ref={recaptchaRef}
    size="invisible"
    sitekey={recaptchaSiteKey}
    onChange={handleRecaptchaChange}
    onErrored={handleReaptchaError}
  />
);
